/**
 * 🔤 FONT REPLACER UTILITY
 * 
 * Einfache Utility zum Ersetzen von Fonts in HeroHeader Widgets
 */

/**
 * Ersetzt alle Fonts in einem HeroHeader Widget
 */
export const replaceHeroHeaderFonts = (widget, newBigFont, newSmallFont) => {
    console.log('🔤 [FONT-REPLACE] Processing widget:', widget.type);
    
    // Nur HeroHeader Widgets
    if (widget.type !== 'HeroHeader') {
        return widget;
    }
    
    const data = widget.data || {};
    
    // Prüfe ob containerSections existiert
    if (!data.containerSections || !Array.isArray(data.containerSections)) {
        console.log('⚠️ [FONT-REPLACE] No containerSections found');
        return widget;
    }
    
    console.log(`🔍 [FONT-REPLACE] Found ${data.containerSections.length} containers`);
    
    // Update containerSections
    const updatedContainerSections = data.containerSections.map((container, containerIndex) => {
        if (!container.contentElements || !Array.isArray(container.contentElements)) {
            return container;
        }
        
        console.log(`  📦 Container ${containerIndex}: ${container.contentElements.length} elements`);
        
        // Update contentElements
        const updatedElements = container.contentElements.map((element, elIndex) => {
            if (element.type !== 'text') {
                return element;
            }
            
            // Bestimme welcher Font basierend auf elementType
            const newFont = element.elementType === 'h1' 
                ? newBigFont 
                : newSmallFont;
            
            console.log(`    ✏️  Element ${elIndex} (${element.elementType}): "${element.fontFamily || 'EMPTY'}" → "${newFont}"`);
            
            return {
                ...element,
                fontFamily: newFont
            };
        });
        
        return {
            ...container,
            contentElements: updatedElements
        };
    });
    
    return {
        ...widget,
        data: {
            ...data,
            containerSections: updatedContainerSections
        }
    };
};

/**
 * Ersetzt Fonts in allen HeroHeader Widgets einer Page
 */
export const replacePageFonts = (pageData, newBigFont, newSmallFont) => {
    console.log('🔤 [FONT-REPLACE] Starting page font replacement');
    console.log(`   Big Font: ${newBigFont}`);
    console.log(`   Small Font: ${newSmallFont}`);
    
    const widgets = pageData.widgets || [];
    console.log(`📊 [FONT-REPLACE] Found ${widgets.length} widgets`);
    
    const updatedWidgets = widgets.map((widget, index) => {
        console.log(`\n🎯 [FONT-REPLACE] Widget ${index}: ${widget.type}`);
        return replaceHeroHeaderFonts(widget, newBigFont, newSmallFont);
    });
    
    console.log('✅ [FONT-REPLACE] Page font replacement complete');
    
    return {
        ...pageData,
        widgets: updatedWidgets
    };
};

